export const changeSearchBy = (payload) => {
  return {
    type: "CHANGE_SEARCHBY",
    payload,
  };
};
